import { ScientificAnalysisEntityCase } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-case'
import { ScientificAnalysisEntityComplementary } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-complementary'
import { ScientificAnalysisEntityPatient } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-patient'
import { ScientificAnalysisEntityPortion } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-portion'
import { ScientificAnalysisEntityRequest } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-request'
import { ScientificAnalysisEntitySample } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-sample'
import { ScientificAnalysisEntitySubportion } from '@/modules/scientific-analysis-module/services/scientific-analysis-dto-subportion'
import { Nullable } from '@/shared/types/app.types'

export type ScientificAnalysisEntityResultType = ScientificAnalysisEntityPatient |
    ScientificAnalysisEntityRequest |
    ScientificAnalysisEntityCase |
    ScientificAnalysisEntitySample |
    ScientificAnalysisEntityPortion |
    ScientificAnalysisEntitySubportion |
    ScientificAnalysisEntityComplementary

export enum ScientificAnalysisSearchEntityType {
    CASE = 'CASE',
    PATIENT = 'PATIENT',
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION',
    REQUEST = 'REQUEST',
    COMPLEMENTARY = 'COMPLEMENTARY'
}

export enum ScientificAnalysisFilterEntityType {
    CASE = 'CASE',
    PATIENT = 'PATIENT',
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION',
    REQUEST = 'REQUEST',
    COMPLEMENTARY = 'COMPLEMENTARY'
}

export enum ScientificAnalysisComparatorType {
    CONTAINS = 'contains',
    NOT_CONTAINS = 'notContains',
    EQUALS = 'equals',
    NOT_EQUAL = 'notEqual',
    STARTS_WITH = 'startsWith',
    ENDS_WITH = 'endsWith',
    NOT_EMPTY = 'notEmpty',
    IN_RANGE = 'inRange',
    EMPTY = 'empty',
    EQUALS_ALL = 'equalsAll'
}

export enum ScientificAnalysisConditionTypeEnum {
    TEXT = 'text',
    DATE = 'date',
    DATETIME = 'dateTime',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    SET = 'set'
}

export enum ScientificAnalysisFieldAdditionalInfo {
    selectHealthManagementArea = 'selectHealthManagementArea',
    selectDepartment = 'selectDepartment',
    selectPersonnel = 'selectPersonnel',
    selectCaseType = 'selectCaseType',
    selectRegime = 'selectCaseType',
    selectPriority = 'selectPriority',
    selectCenter = 'selectCenter',
    selectPhysicianPetitioner = 'selectPhysicianPetitioner',
    selectStatusCase = 'selectStatusCase',
    selectAttachmentFormat = 'selectAttachmentFormat',
    selectAttachmentType = 'selectAttachmentType',
    selectVirtualShelf = 'selectVirtualShelf',
    selectSampleTag = 'selectSampleTag',
    selectSampleType = 'selectSampleType',
    selectFixer = 'selectFixer',
    selectSampleProcess = 'selectSampleProcess',
    selectTopographicCode = 'selectTopographicCode',
    multiselectTopographicCode = 'multiselectTopographicCode',
    selectMorphologicCode = 'selectMorphologicCode',
    multiselectMorphologicCode = 'multiselectMorphologicCode',
    selectProcedure = 'selectProcedure',
    selectMostLikelyMorphologicCode = 'selectMostLikelyMorphologicCode',
    selectStatusSample = 'selectStatusSample',
    selectCodification = 'selectCodification',
    selectGender = 'selectGender',
    selectValuableConceptURV = 'selectValuableConceptURV',
    selectValuableConceptUCL = 'selectValuableConceptUCL',
    selectProtocol = 'selectProtocol',
    multiselectProtocol = 'multiselectProtocol',
    selectProcessor = 'selectProcessor',
    selectMicrotome = 'selectMicrotome',
    selectPortionState = 'selectPortionState',
    selectPortionType = 'selectPortionType',
    selectPatientIdentifier = 'selectPatientIdentifier',
    selectUnitTime = 'selectUnitTime',
    selectStatusRequest = 'selectStatusRequest',
    selectSubportionStatus = 'selectSubportionStatus',
    selectSubportionType = 'selectSubportionType',
    selectAssayGroup = 'selectAssayGroup',
    selectAssay = 'selectAssay'

}

export interface ScientificAnalysisConditionTypeDTO {
    type: ScientificAnalysisConditionTypeEnum
    allowedComparatorTypes: ScientificAnalysisComparatorType[]
    additionalInfo: ScientificAnalysisFieldAdditionalInfo | null
}

export interface ScientificAnalysisFieldDTO {
    fieldName: string,
    translatedFieldName: string,
    allowedConditionsTypes: ScientificAnalysisConditionTypeDTO[]
}

export interface ScientificAnalysisMetadataEntityFilterConditionsResponse{
    metadataFieldFilterConditionsResponses: ScientificAnalysisFieldDTO[]
    groupedByParent: boolean
}

export interface SimpleListEntityResponse {
    id: string
    label: string
}

export enum SimpleListEntity {
    ATTACHMENT_SUPPORTED_MIME_TYPES = 'ATTACHMENT_SUPPORTED_MIME_TYPES',
    ATTACHMENT_TYPE = 'ATTACHMENT_TYPE',
    CASE_TYPE = 'CASE_TYPE',
    CASE_STATE = 'CASE_STATE',
    CENTER = 'CENTER',
    DEPARTMENT = 'DEPARTMENT',
    FIXER = 'FIXER',
    GENDER = 'GENDER',
    HEALTH_MANAGEMENT_AREA = 'HEALTH_MANAGEMENT_AREA',
    MORPHOLOGIC_CODE = 'MORPHOLOGIC_CODE',
    MOST_LIKELY_MORPHOLOGIC_CODE = 'MOST_LIKELY_MORPHOLOGIC_CODE',
    PATIENT_AGE = 'PATIENT_AGE',
    PERSONNEL = 'PERSONNEL',
    PETITIONER = 'PETITIONER',
    PROCEDURE = 'PROCEDURE',
    PRIORITY = 'PRIORITY',
    REGIME = 'REGIME',
    SAMPLE_PROCESS = 'SAMPLE_PROCESS',
    SAMPLE_STATES = 'SAMPLE_STATES',
    SAMPLE_TAG = 'SAMPLE_TAG',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    VIRTUAL_SHELF = 'VIRTUAL_SHELF',
    VALUABLE_CONCEPT_OF_TYPE_URV ='VALUABLE_CONCEPT_OF_TYPE_URV',
    VALUABLE_CONCEPT_OF_TYPE_UCL = 'VALUABLE_CONCEPT_OF_TYPE_UCL',
    PROTOCOL = 'PROTOCOL',
    PROCESSOR = 'PROCESSOR',
    MICROTOME = 'MICROTOME',
    PORTION_STATE = 'PORTION_STATE',
    PORTION_TYPE = 'PORTION_TYPE',
    REQUEST_STATE = 'REQUEST_STATE',
    SUBPORTION_STATE = 'SUBPORTION_STATE',
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    ASSAYGROUP = 'ASSAYGROUP',
    ASSAY = 'ASSAY'
}

export interface ConditionFilterRequest {
    fieldName: string
    conditionType: ScientificAnalysisComparatorType
    value: Nullable<string | string[]>
    valueTo: Nullable<string | string[]>
}
export interface FilterRequest {
    conditions: ConditionFilterRequest[]
}
export interface FilterGroupRequest {
    entityType: ScientificAnalysisFilterEntityType,
    groupedByParentEntity: boolean,
    filters: FilterRequest[]
}

export interface ScientificAnalysisTemplateHeader{
    id: number,
    name: string,
    lastModifiedDate: string,
    version:number
}

export interface ScientificAnalysisSaveResponse extends ScientificAnalysisTemplateHeader{
    template:string
}

export enum CaseSummaryReportGroupingTypeEnum {
    PATHOLOGIST ='PATHOLOGIST',
    PATIENT ='PATIENT'
}
